<template>
  <v-app>
    <v-app-bar class="container-wide-screen" fixed>
      <router-link to="/locations">
        <img
          class="mx-2"
          src="@/assets/images/logo.svg"
          max-height="40"
          max-width="40"
          contain
        />
      </router-link>
      <v-toolbar-title>Business Anvio</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tabs optional centered style="width: auto">
        <v-tab v-if="currentUser && currentUser.role >= 20" to="/locations">{{
          $t("menuLocations")
        }}</v-tab>
        <v-tab
          v-if="checkPermission('accounts.anvio.techsessions')"
          to="/control"
          >{{ $t("menuControl") }}</v-tab
        >
      </v-tabs>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
          v-if="language == 'ru'"
          text
          rounded
          slot="activator"
          @click="changeLanguage('en')"
          ><span>RU</span></v-btn
        >
        <v-btn
          v-if="language == 'en'"
          text
          rounded
          slot="activator"
          @click="changeLanguage('ru')"
          ><span>EN</span></v-btn
        >
        <v-menu offset-y tile bottom left v-if="currentUser" elevation="1">
          <template v-slot:activator="{ on }">
            <v-btn text rounded slot="activator" v-on="on">
              <v-avatar>
                <v-img
                  v-if="currentUser.avatar"
                  :src="currentUser.avatar"
                ></v-img>
                <v-img v-else src="./assets/images/user.png"></v-img>
              </v-avatar>
            </v-btn>
          </template>
          <v-list>
            <v-list-item link to="/user">
              <v-list-item-icon>
                <v-icon>mdi-account-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ $t("menuProfile") }}</v-list-item-title>
            </v-list-item>
            <!-- <v-list-item
              link
              to="/transactions"
            >
              <v-list-item-icon>
                <v-icon>mdi-cash-register</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ $t('menuTransactions') }}</v-list-item-title>
            </v-list-item> -->
            <v-list-item link @click="logOut()">
              <v-list-item-icon>
                <v-icon>mdi-exit-run</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ $t("menuExit") }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn text rounded slot="activator" to="/login" v-else
          ><span>{{ $t("menuLogIn") }}</span></v-btn
        >
      </v-toolbar-items>
    </v-app-bar>
    <v-app-bar class="container-narrow-screen" fixed>
      <router-link to="/locations">
        <img
          class="mt-1"
          src="@/assets/images/logo.svg"
          max-height="40"
          max-width="40"
          contain
        />
      </router-link>
      <v-tabs optional centered hide-slider>
        <v-tab v-if="currentUser && currentUser.role >= 20" to="/locations">{{
          $t("menuLocations")
        }}</v-tab>
        <v-tab
          v-if="checkPermission('accounts.anvio.techsessions')"
          to="/control"
          >{{ $t("menuControl") }}</v-tab
        >
      </v-tabs>
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" fixed temporary>
      <v-list nav dense>
        <v-list-item-group
          v-model="group"
          active-class="red--text text--accent-4"
        >
          <v-list-item to="/locations" exact>
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t("menuHome") }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="language === 'ru'" @click="changeLanguage('en')">
            <v-list-item-icon>
              <v-icon>mdi-earth</v-icon>
            </v-list-item-icon>
            <v-list-item-title>RU</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="language === 'en'" @click="changeLanguage('ru')">
            <v-list-item-icon>
              <v-icon>mdi-earth</v-icon>
            </v-list-item-icon>
            <v-list-item-title>EN</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="currentUser" to="/user" exact>
            <v-list-item-icon>
              <v-icon>mdi-account-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t("menuProfile") }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="currentUser" @click="logOut()" exact>
            <v-list-item-icon>
              <v-icon>mdi-exit-run</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t("menuExit") }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-else to="/login" exact>
            <v-list-item-icon>
              <v-icon>mdi-login</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t("menuLogIn") }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="$route.params.location_id"
            :to="{
              name: 'booking_admin',
              params: { location_id: $route.params.location_id },
            }"
            exact
          >
            <v-list-item-icon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M12 14a1 1 0 1 0-1-1a1 1 0 0 0 1 1Zm5 0a1 1 0 1 0-1-1a1 1 0 0 0 1 1Zm-5 4a1 1 0 1 0-1-1a1 1 0 0 0 1 1Zm5 0a1 1 0 1 0-1-1a1 1 0 0 0 1 1ZM7 14a1 1 0 1 0-1-1a1 1 0 0 0 1 1ZM19 4h-1V3a1 1 0 0 0-2 0v1H8V3a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Zm1 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9h16Zm0-11H4V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1ZM7 18a1 1 0 1 0-1-1a1 1 0 0 0 1 1Z"
                />
              </svg>
            </v-list-item-icon>
            <v-list-item-title>{{ $t("navBookingAdmin") }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="
              location && location.role.id === 40 && $route.params.location_id
            "
            :to="{
              name: 'location_management',
              params: { location_id: $route.params.location_id },
            }"
          >
            <v-list-item-icon>
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $t("navLocationManagement")
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
              v-if="$route.params.location_id && checkPermission('accounts.anvio.certificate')"
              :to="{
              name: 'certificates',
              params: { location_id: $route.params.location_id },
            }"
              exact
          >
            <v-list-item-icon>
              <v-icon>mdi-certificate</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t("navCertificates") }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main style="padding: 64px 0">
      <router-view></router-view>
    </v-main>
    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
    >
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>
    <v-sheet class="alerts" v-if="errors.length">
      <v-alert
        elevation="2"
        type="error"
        dense
        dismissible
        v-for="(err, k) in errors"
        :key="k"
        style="z-index: 100"
        >{{ err }}</v-alert
      >
    </v-sheet>
    <v-sheet class="alerts" v-if="alerts.length">
      <v-alert
        elevation="2"
        type="success"
        dense
        dismissible
        v-for="(alert, k) in alerts"
        :key="k"
        style="z-index: 100"
        >{{ alert }}</v-alert
      >
    </v-sheet>
    <v-card
      class="navbar container-wide-screen"
      v-if="$route.params.location_id"
    >
      <v-navigation-drawer permanent floating expand-on-hover>
        <v-list dense>
          <v-list-item
            v-if="checkPermission('accounts.anvio.multibooking')"
            link
            :to="{
              name: 'multibooking_admin',
              params: { location_id: $route.params.location_id },
            }"
          >
            <v-list-item-icon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  d="M17 7h6v16H7v-4m16-8h-6M13 0v3M1 7h16M1 3h16v16H1V3Zm4-3v3m-1 8h2m2 0h6M4 15h2m2 0h6"
                />
              </svg>
            </v-list-item-icon>
            <v-list-item-title>{{
              $t("navMultiBookingAdmin")
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            :to="{
              name: 'booking_admin',
              params: { location_id: $route.params.location_id },
            }"
          >
            <v-list-item-icon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M12 14a1 1 0 1 0-1-1a1 1 0 0 0 1 1Zm5 0a1 1 0 1 0-1-1a1 1 0 0 0 1 1Zm-5 4a1 1 0 1 0-1-1a1 1 0 0 0 1 1Zm5 0a1 1 0 1 0-1-1a1 1 0 0 0 1 1ZM7 14a1 1 0 1 0-1-1a1 1 0 0 0 1 1ZM19 4h-1V3a1 1 0 0 0-2 0v1H8V3a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Zm1 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9h16Zm0-11H4V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1ZM7 18a1 1 0 1 0-1-1a1 1 0 0 0 1 1Z"
                />
              </svg>
            </v-list-item-icon>
            <v-list-item-title>{{ $t("navBookingAdmin") }}</v-list-item-title>
          </v-list-item>
          <v-list-item
              v-if="$route.params.location_id && checkPermission('accounts.anvio.certificate')"
              :to="{
              name: 'certificates',
              params: { location_id: $route.params.location_id },
            }"
              exact
          >
            <v-list-item-icon>
              <v-icon>mdi-certificate</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t("navCertificates") }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="location && location.role.id === 40"
            link
            :to="{
              name: 'location_management',
              params: { location_id: $route.params.location_id },
            }"
            exact
          >
            <v-list-item-icon>
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $t("navLocationManagement")
            }}</v-list-item-title>
          </v-list-item>
          <!--					<v-list-item v-if="location && location.role.id === 40" link :to="{name: 'tools', params: { location_id: $route.params.location_id}}">-->
          <!--						<v-list-item-icon>-->
          <!--							<v-icon>mdi-tools</v-icon>-->
          <!--						</v-list-item-icon>-->
          <!--						<v-list-item-title>{{ $t('navTools') }}</v-list-item-title>-->
          <!--					</v-list-item>-->
          <!--          <v-list-item v-if="location && location.role.id === 40" link :to="{name: 'statistic', params: { location_id: $route.params.location_id}}">-->
          <!--            <v-list-item-icon>-->
          <!--              <v-icon>mdi-chart-line</v-icon>-->
          <!--            </v-list-item-icon>-->
          <!--            <v-list-item-title>{{ $t('navStatistic') }}</v-list-item-title>-->
          <!--          </v-list-item>-->
        </v-list>
      </v-navigation-drawer>
    </v-card>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import getDefaultStartDate from "./mixins/helper";
import getDefaultEndDate from "./mixins/helper";

export default {
  name: "App",

  mixins: [getDefaultStartDate, getDefaultEndDate],

  data() {
    return {
      fab: false,
      drawer: false,
      group: null,
    };
  },

  computed: {
    ...mapGetters([
      "currentUser",
      "language",
      "errors",
      "alerts",
      "checkPermission",
      "location",
    ]),
  },

  methods: {
    ...mapActions(["loadUser", "logOut", "changeLanguage"]),
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },

  created() {
    this.loadUser();
    this.$i18n.locale = this.language;
  },
};
</script>

<style lang="scss" scoped>
.alerts {
  background-color: transparent !important;
  position: fixed;
  right: 16px;
  z-index: 1;
  top: 80px;

  .v-alert {
    margin-bottom: 0;

    + .v-alert {
      margin-top: 16px;
    }
  }
}

.navbar {
  position: fixed;
  height: auto;
  z-index: 10;
  top: 162px;
}
</style>

<style>
.v-toolbar__content {
  justify-content: space-between;
}
.v-slide-group__prev {
  display: none !important;
}
.container-wide-screen {
  display: block;
}
@media (max-width: 1163px) {
  .container-wide-screen {
    display: none;
  }
}
.container-narrow-screen {
  display: none;
}
@media (max-width: 1163px) {
  .container-narrow-screen {
    display: block;
  }
}
</style>
